var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup33893(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9178 19277)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9178, -19277)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    transform: "translate(3 2)",
    fill: "#15b5d8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.028 0.925)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9156.314 -19295.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.138,263.75h-2.632a1.307,1.307,0,0,0-1.306,1.306v2.019a1.307,1.307,0,0,0,1.306,1.306h2.632a1.307,1.307,0,0,0,1.306-1.306v-2.019A1.307,1.307,0,0,0,252.138,263.75Zm.356,3.325a.357.357,0,0,1-.356.356h-2.632a.357.357,0,0,1-.356-.356v-2.019a.357.357,0,0,1,.356-.356h2.632a.357.357,0,0,1,.356.356Z",
    transform: "translate(-238.376 -254.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.37,36.591a.441.441,0,0,0-.063-.234l-2.881-5.066a.477.477,0,0,0-.412-.241H3.352a.469.469,0,0,0-.412.241L.063,36.358A.48.48,0,0,0,0,36.591a2.778,2.778,0,0,0,1.662,2.541v8.355a.476.476,0,0,0,.475.475H17.229a.476.476,0,0,0,.475-.475v-8.3a.209.209,0,0,0,0-.051A2.786,2.786,0,0,0,19.37,36.591ZM3.629,32H15.737l2.252,3.962H1.381Zm10.156,4.908a1.825,1.825,0,0,1-3.594,0Zm-4.6,0a1.828,1.828,0,0,1-3.6,0Zm-8.2,0h3.6a1.828,1.828,0,0,1-3.6,0Zm7,10.1H5.248V41.887a.677.677,0,0,1,.677-.677H7.306a.677.677,0,0,1,.677.677v5.126Zm8.775,0H8.929V41.887A1.629,1.629,0,0,0,7.3,40.26H5.921a1.629,1.629,0,0,0-1.627,1.627v5.129H2.612V39.366c.055,0,.111,0,.166,0a2.775,2.775,0,0,0,2.3-1.227,2.776,2.776,0,0,0,4.607,0,2.768,2.768,0,0,0,4.6,0,2.775,2.775,0,0,0,2.3,1.227c.055,0,.107,0,.162,0v7.647Zm-.162-8.593a1.824,1.824,0,0,1-1.8-1.5h3.6A1.836,1.836,0,0,1,16.592,38.42Z",
    transform: "translate(0 -31.05)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    transform: "translate(-9156 -19254)",
    fill: "#15b5d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.711,17.488a.44.44,0,0,0,.406-.271L21.3,11.948a.439.439,0,0,0-.406-.607H9.258l-.437-1.047a.439.439,0,0,0-.405-.27H7.754L4.869,7.14a2.266,2.266,0,0,0-.233-.188,2.195,2.195,0,1,0-2.606,0,2.187,2.187,0,0,0-.892,1.756V13.1a2.163,2.163,0,0,0,.371,1.2L.489,19.426a1.317,1.317,0,1,0,2.583.514l.363-1.823L3.8,19.939a1.317,1.317,0,0,0,2.584-.514L5.309,14.039a2.142,2.142,0,0,0,.219-.941V11.523l.308.308a1.349,1.349,0,0,0,1.863,0,1.307,1.307,0,0,0,.385-.929h.039l2.549,6.147-.65,1.589a.439.439,0,0,0,.406.605h.01a1.292,1.292,0,0,0-.081.439,1.317,1.317,0,1,0,2.634,0,1.3,1.3,0,0,0-.081-.439h3.674a1.292,1.292,0,0,0-.081.439,1.317,1.317,0,1,0,2.172-.994.433.433,0,0,0-.416-.323H11.082l.36-.878ZM2.016,5.2A1.317,1.317,0,1,1,3.333,6.512,1.319,1.319,0,0,1,2.016,5.2Zm.195,14.573A.439.439,0,1,1,1.35,19.6L2.264,15a2.179,2.179,0,0,0,.6.234l.126.632-.776,3.9ZM7.078,11.21a.44.44,0,0,1-.621,0L5.4,10.152,3.566,8.319a.439.439,0,1,0-.621.621L4.65,10.645V13.1a1.3,1.3,0,0,1-.182.654.437.437,0,0,0-.05.306l1.1,5.54a.439.439,0,1,1-.861.171l-1-5.01a.439.439,0,0,0-.405-.353A1.315,1.315,0,0,1,2.016,13.1V8.707A1.319,1.319,0,0,1,3.333,7.39a1.305,1.305,0,0,1,.935.39l2.81,2.809a.44.44,0,0,1,0,.621Zm10.743,8.034a.439.439,0,1,1-.439.439A.44.44,0,0,1,17.821,19.244Zm-6.146,0a.439.439,0,1,1-.439.439A.44.44,0,0,1,11.674,19.244ZM9.622,12.219H20.236l-.364.878H9.986Zm1.091,2.634-.364-.878h9.16l-.364.878Zm.364.878h7.705l-.364.878H11.44Z",
    transform: "translate(-9166.463 -19263)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33893);
export default __webpack_public_path__ + "static/media/Group 33893.f25378be42ec09ae113316de0f66b1c2.svg";
export { ForwardRef as ReactComponent };